import { render, staticRenderFns } from "./AnalisiMenuSidebar.vue?vue&type=template&id=67a6a57a&scoped=true&"
import script from "./AnalisiMenuSidebar.vue?vue&type=script&lang=js&"
export * from "./AnalisiMenuSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AnalisiMenuSidebar.vue?vue&type=style&index=0&id=67a6a57a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a6a57a",
  null
  
)

export default component.exports